import { StudentsUIProvider } from "./StudentsUIContext";
import { StudentsCard } from "./StudentsCard";

export function StudentsPage({
  date,
  sectionId,
  absenteeismStatus,
  isApplication,
  isMail,
  isSms
}) {
  return (
    <StudentsUIProvider studentsUIParameters={{ date, sectionId, absenteeismStatus, isApplication, isMail, isSms }}>
      <StudentsCard />
    </StudentsUIProvider>
 );
}